import { Component } from '@angular/core';

@Component({
  selector: 'app-files-root',
  templateUrl: './files-root.component.html',
})
export class FilesRootComponent {}
